var s = window.s || {};

s.popupHandScripts = function($popup){
	this.initPageCaptcha($popup);
	this.initHandAjaxForm($popup);
	this.initInputs($popup);
	this.initFileInput($popup);
};

s.initHomePageRequestPopup = function(){
	var
		context = $('.request-section .holder', s.dom.main),
		armsCollection = $('.left-arm, .right-arm', context),
		button = $('.btn-request');

	button.on('mouseenter', function(){
		armsCollection.stop().fadeTo(300,1);
	}).on('mouseleave', function(){
		armsCollection.stop().fadeTo(300,0);
	})

	button.on('click', function(event){
		event.preventDefault();
		event.stopPropagation();

		var el = $(event.currentTarget);
		s.loadPopup(el.attr("data-popup-name"), el.attr("data-popup-url"), s.showHandPopup, [el, context]);

		return false;
	})

	this.dom.popupHandHolder = $(this.tpls.popupHandHolder).appendTo(this.dom.body);
	this.dom.popupHandHolder.on('click', function(e){
		e.preventDefault();
		s.closeHandPopup();
	});
};

s.showHandPopup = function($popup, el, context)
{
	context.animate({'width':'300px'},500,function(){
		$('.js-box-side',context).fadeTo(300,0);

		$('.js-box-inner',context).fadeTo(300,0,function(){

			context.animate({'width':'419px'},500);

			$('.js-box',context).animate({'width':'363px','height':'430px'},500,function(){
				$popup.css('position', 'absolute');
				$('form', $popup).attr('action', el.attr('href'));
				s.openHandPopup($popup, context);
			});

		});
	});
}

s.openHandPopup = function($popup, context){
	var s = this;
	$popup.on('click.closePopup', '.js-close-popup', function(e){
		e.preventDefault();
		s.closeHandPopup();
	});

	// Set popup last in the body
	this.dom.body.append($popup);
	var len = this.dom.openedPopups.length;
	if (len === 0)
	{
		// Show popup holder
		this.fitHandPopupHolder();
		this.dom.popupHandHolder.fadeIn(200);

		this.dom.window
			.on('resize.popup', function(){
				s.fitHandPopupHolder();
				s.alignHandPopup(context);
			})
			.on('scroll.popup', function(){
				s.fitHandPopupHolder();
			})
			;
		// Bind close popup by Esc key
		$(document).on('keydown.closePopup', function(e){
			if (e.keyCode == s.keyCode.ESCAPE) {
				s.closeHandPopup();
			}
		});
	}
	else
	{
		// Hide previos popup
		this.dom.openedPopups[len-1].fadeOut(200);
	}
	this.dom.openedPopups.push($popup);
	$popup.css('left', -9999).show();
	this.alignHandPopup(context);
	$popup.hide().fadeIn(300);

	s.popupHandScripts($popup);

	$popup.triggerHandler('open.popup');
	$popup = null;
};

s.closeHandPopup = function($popup){

	var s = this;
	var len = this.dom.openedPopups.length;

	if ( ! len)
	{
		// No has opened popups
		return;
	}

	$popup = this.dom.openedPopups.pop();

	$popup.triggerHandler('close.popup');
	$popup.off().fadeOut(200, function(){
		var context = $('.request-section .holder', s.dom.main);
		$('.js-box',context).animate({'width':'242px','height':'266px'},500);
		context.animate({'width':'300px'},500,function(){
			$('.js-box-side',context).fadeTo(300,1);
			$('.js-box-inner',context).fadeTo(300,1,function(){
				context.animate({'width':'930px'},500);
			})
		})

		$(this).remove();
	});

	$popup = null;

	// Hide popup bg
	this.dom.popupHandHolder.fadeOut(200);
	// Unbind popup events from window
	this.dom.window
		.off('resize.popup')
		.off('scroll.popup');
	// Unbind close popup by Esc key
	$(document).off('keydown.closePopup');

};

s.fitHandPopupHolder = function(){
	this.dom.popupHandHolder.css({
		height: Math.max(this.dom.body.height(), this.dom.window.height()),
		left: 0
	})
	.children('.bg').css({
		height: $(document).height(),
		width: this.dom.window.width() + this.dom.window.scrollLeft()
	});
};


s.alignHandPopup = function(context){
	var len = this.dom.openedPopups.length;
	if (len)
	{
		var $popup = this.dom.openedPopups[len-1],
		$win = this.dom.window,
		pos = {};

		if ($popup.is(':animated')){
			$popup.stop(true,true);
		}

		pos.top = context.offset().top;
		pos.left = context.offset().left;

		$popup.css(pos);
	}
};


/**************************/
/*    Ajax Forms group    */
/**************************/
s.handlerHandSubmitAjaxForm = function(event){
	event.preventDefault();
	var $form = $(this);

	if ($form.hasClass('in-submit'))
		return;

	$form
		.removeClass('sended')
		.find('.common-error-msg')
			.remove();

	var url = $form.attr('data-url') || $form.attr('action');
	if (! url)
		return;

	if ( ! s.checkFormAjaxFields($form))
		return;

	var form_id = $form.attr('id');
	if ( ! form_id)
	{
		form_id = s.getId();
		$form.attr('id', form_id);
	}



	$form.addClass('in-submit');
	s.showFormAjaxLoader($form);

	var form_type = $form.attr('enctype');

	$.ajax({
		url: url,
		data: $form.serializeArray(),
		type: "POST",
		dataType: "json",
		cache: false
	})
	.done(function(data, textStatus, jqXHR){
		s.processHandSuccessAjaxFormResponse(form_id, data, textStatus, jqXHR);
	})
	.fail(function(jqXHR, textStatus, errorThrown){
		s.processErrorAjaxFormResponse(form_id, jqXHR, textStatus, errorThrown);
	})
	.always(function(){
		s.hideFormAjaxLoader($('#'+form_id).removeClass('in-submit'));
		$('.captcha-holder img', $form).trigger('click');
	})
	;

	$form = null;
};

s.processHandSuccessAjaxFormResponse = function($form, response, textStatus, jqXHR){
	if (typeof $form === 'string')
	{
		$form = $('#'+$form);
	}

	$form.triggerHandler('request.done', [response, textStatus, jqXHR]);

	if (response.dont_process !== true)
	{
		if (response.success)
		{
			var $popup = $form.closest('.popup');

			if (response.dont_hide_form !== true)
			{
				$form.fadeOut(300);

				if ($popup.length && response.dont_show_message === true)
				{
					s.closeHandPopup($popup);
				}
			}
			else
			{
				s.hideFormErrors($form);
				s.clearAjaxForm($form);
				$form.addClass('sended')
				.find('.article-form:not(.message-ok)')
				.fadeOut(200, function(){
					$(this).remove();
					$('.message-ok',$form)
					.show();
				});
			}

			if (response.dont_show_message !== true)
			{
				var message = response.message || 'Ваше сообщение успешно отправлено.';
				var title = response.message_title || 'Сообщение отправлено';
				var timeout = response.message_timeout;
				var onClose = null;

				if (response.redirect)
				{
					var redirect = response.redirect;
					onClose = function(){s.mainAjaxLoader.getPage(redirect);};
				}
				else
				{
					onClose = function(){if($popup.length)s.closeHandPopup($popup);};
				}

				s.createPopup('<p>'+message+'</p>', {title: title, onClose: onClose, autoCloseTimeout: timeout});
			}
			else
			{
				if (response.redirect)
				{
					s.mainAjaxLoader.getPage(response.redirect);
				}
			}
		}
		else
		{
			s.showFormErrors($form, response.errors || {});
		}
	}

	$form = response = textStatus = jqXHR = null;
};

s.initHandAjaxForm = function(context){
	(context || this.dom.main)
		.on('submit.ajaxForm', 'form', this.handlerHandSubmitAjaxForm)
		.on('change.ajaxForm', ':input', function(e){
			$(this).closest('form')
				.removeClass('incorrect')
				.find('.incorrect')
					.removeClass('incorrect');
		})
		;
	context = null;
};

s.initHomeReviews = function () {
	$('.js-review').bxSlider({
		pager: false,
		autoHover: true,
		adaptiveHeight: true,
		prevText: '',
		nextText: ''
	});

	$('[data-fancybox]').fancybox({
		selector : '[data-fancybox="images"]',
		protect: true,
		keyboard: false,
		arrows: false,
		buttons : [
			'close'
		],
	});
}

